import React from 'react';
import {VjsVideo} from 'ui-components/VjsVideo';
import {
	getVimeoOpts,
	getYoutubeOpts
} from 'utils/videoUtils';
import {stopPropagation} from 'utils/eventUtils';


export const Video = ({
	url,
	videoEnded,
	auto,
	...props
}) => {
	let opts = getYoutubeOpts(url) || getVimeoOpts(url);
	return opts && (
		<div
			data-vjs-player
			onClick={stopPropagation}
			className="video-wrap"
		>
			<VjsVideo
				aspect={16 / 9}
				url={url}
				autoplay={auto}
				controls={true}
				{...opts}
				onPlayerPaused={() => {
					// console.log("PAUSED");
				}}
				onPlayerEnded={() => {
					if (typeof videoEnded === 'function'){
						videoEnded();
					}
				}}
				onPlayerPlay={() => {
					// console.log("PLAY");
				}}
			/>
		</div>
	);
}
export default Video;